import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface AppData {
  name: string;
  version: string;
  buildTime: string;
  releaseNotes: string;
}

export interface AppUpdateAvailableEvent {
  currentHash: string;
  newHash: string;
  appData: AppData;
}

export interface IAppUpdateAdapter {
  readonly updateAvailable$: Observable<AppUpdateAvailableEvent>;
  initialize(): void;
  checkForUpdate(): Promise<boolean>;
  downloadUpdate(): Promise<void>;
  applyUpdate(): Promise<void>;
  restartApp(): Promise<void>;
}

export const APP_UPDATE_ADAPTER = new InjectionToken<IAppUpdateAdapter>('APP_UPDATE_ADAPTER');
